export const countryCodes = [
  { value: '+1', name: 'US/CA +1' },
  { value: '+49', name: 'DE +49' },
  { value: '+33', name: 'FR +33' },
  { value: '+44', name: 'UK +44' },
  { value: '+380', name: 'UA +380' },
  { value: '+48', name: 'PL +48' },
  { value: '+233', name: 'GH +233' },
]
